
import { Router } from '../routes';
import './app.module.scss';

export function App() {
  return <Router />;
}

export default App;